import { render } from "./btsGallery.vue?vue&type=template&id=5e30ab62"
import script from "./btsGallery.vue?vue&type=script&lang=js"
export * from "./btsGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__